export const getStringArrayFromQueryString = (urlParams, paramName, defaultValue = []) => {
    const value = decodeURIComponent(urlParams.get(paramName) ?? '');
    return !value ? defaultValue : value.split(',');
};
export const getNumberArrayFromQueryString = (urlParams, paramName, defaultValue = []) => {
    const value = decodeURIComponent(urlParams.get(paramName) ?? '');
    return !value ? defaultValue : value.split(',').map((x) => +x);
};
export const getNumberFromQueryString = (urlParams, paramName, defaultValue) => {
    const value = decodeURIComponent(urlParams.get(paramName) ?? '');
    return !value ? defaultValue : +value;
};
export const getStringFromQueryString = (urlParams, paramName, defaultValue = '') => {
    return decodeURIComponent(urlParams.get(paramName) ?? defaultValue);
};
export const getBooleanFromQueryString = (urlParams, paramName, defaultValue = false) => {
    const value = urlParams.get(paramName);
    const decodedValue = decodeURIComponent(value).toLowerCase();
    if (decodedValue === 'true') {
        return true;
    }
    return defaultValue;
};
export const serializeParameter = (params) => {
    const searchParams = new URLSearchParams();
    if (params)
        Object.keys(params).forEach((key) => {
            const v = params[key];
            if (v.toString())
                searchParams.append(key, v.toString());
        });
    return searchParams.toString();
};
